import PropTypes from 'prop-types';
import React, { useRef, useEffect, useState } from 'react';
import { Link } from 'gatsby-link';

import Button from '../button/Button';
import Logo from '../../images/logo_new.png';
import useEnrollmentUrl from '../../hooks/useEnrollmentUrl';
import { useHeaderItemsPreview } from '../../hooks/useHomePagePreview';

import './Header.scss';

export default function Header({
  items,
  light,
  displaySleepHealthReportBanner,
}) {
  const { enrollmentUrl } = useEnrollmentUrl();

  const [pageName, setPageName] = useState(null);
  const headerRef = useRef();

  const SCROLL_BREAKPOINT = 45;
  const CLASS_NAME_HEADER = `header ${displaySleepHealthReportBanner && 'header--with-sleep-health-report-banner'}`;

  useEffect(() => {
    document.addEventListener('scroll', () => {
      if (headerRef.current) {
        if (window.pageYOffset > SCROLL_BREAKPOINT) {
          headerRef.current.className = `${CLASS_NAME_HEADER} fixed`;
        } else {
          headerRef.current.className = CLASS_NAME_HEADER;
        }
      }
    });

    if (window.location.pathname.startsWith('/booking/preview')) {
      const params = new URLSearchParams(window.location.search);
      setPageName(params.get('id'));
    }
  }, []);

  const { headerItems: previewItems } = useHeaderItemsPreview(pageName);

  function closeMenu() {
    document.getElementById('menuToggle').checked = false;
  }

  return (
    <div className={CLASS_NAME_HEADER} ref={headerRef}>
      <Link to="/" onClick={closeMenu}>
        <img className="header__logo" src={Logo} alt="Dreem Health logo" />
      </Link>
      <input type="checkbox" id="menuToggle" />
      {!light && (
        <>
          <label htmlFor="menuToggle" className="burgerMenu">
            <span>{ }</span>
          </label>
          <nav className="menu">
            { (previewItems || items).map((item) => (
              <Button
                key={item.text}
                text={item.text}
                className={`finer ${item.type}`}
                link={item.link.replaceAll('%enrollmentUrl%', enrollmentUrl)}
                displayArrow={['salmon', 'blue'].includes(item.type)}
                onClick={() => {
                  closeMenu();

                  if (item.link === '%enrollmentUrl%' && window.posthog) {
                    window.posthog.capture('cta_enroll_now', { section: item.text });
                  }
                }}
              />
            ))}
          </nav>
        </>
      )}
    </div>
  );
}

Header.defaultProps = {
  light: false,
  displaySleepHealthReportBanner: false,
};

Header.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    link: PropTypes.string,
    type: PropTypes.string,
  })).isRequired,
  light: PropTypes.bool,
  displaySleepHealthReportBanner: PropTypes.bool,
};
